import { defineStore } from 'pinia';
import axios from 'axios';

export const useAuthStore = defineStore('auth', {
  state: () => ({ // data
    currentUser: {},
    // eslint-disable-next-line fp/no-nil
    currentUserPromise: null,
    currentAgency: {},
    currentAgencyShort: {},
    // eslint-disable-next-line fp/no-nil
    currentAgencyPromise: null,
    // eslint-disable-next-line fp/no-nil
    currentAgencyPromiseShort: null,
    permissions: new Set(),
    // eslint-disable-next-line fp/no-nil
    permissionsPromise: null,
  }),
  getters: { // computed
    isAuth () {
      return this.currentUser.id && this.currentAgency.id;
    },
    isPublic () {
      return window.location.pathname.startsWith('/pub/');
    },
  },
  actions: { // methods
    all () {
      return Promise.all([this.authUser(), this.authAgency(), this.authPermissions()]);
    },
    authPublic () {
      return this.authPublicPromise ||= axios.get(`${window.location.pathname}/form_share`);
    },
    async authUser () {
      if (this.currentUserPromise) return this.currentUserPromise;

      if (this.isPublic) {
        this.currentUserPromise =  this.authPublic().then( r => ({
          // eslint-disable-next-line camelcase
          permission_set: { id: r.data.permission_set_id },
        }));
      } else {
        this.currentUserPromise = axios.get('/users/current_user')
            .then(r => {
              const o = r.data;
              // eslint-disable-next-line max-len
              if (window.Sentry) window.Sentry.setUser({ id: o.uid, email: o.email,  username: `${o.first_name} ${o.last_name}` });
              return this.currentUser = o;
            });
      }

      return this.currentUserPromise;
    },
    authAgency () {
      if (this.currentAgencyPromise) return this.currentAgencyPromise;

      this.currentAgencyPromise = axios.get('/agencies/notneeded')
          .then(r => this.currentAgency = r.data);
      return this.currentAgencyPromise;
    },
    authAgencyShort () {
      if (this.currentAgencyPromiseShort) return this.currentAgencyPromiseShort;

      this.currentAgencyPromiseShort = axios.get('/agencies/notneeded?short=1')
          .then(r => this.currentAgencyShort = r.data);
      return this.currentAgencyPromiseShort;
    },
    reloadUser () {
      // eslint-disable-next-line fp/no-nil
      this.currentUserPromise = null;
      return this.authUser();
    },
    authPermissions () {
      if (this.permissionsPromise) return this.permissionsPromise;

      this.permissionsPromise = axios.get('/users/permissions')
          .then(r => this.permissions = new Set(r.data));
      return this.permissionsPromise;
    },
    hasPermission (...requested) {
      return requested.map(e => e.trim()).every(e => this.permissions.has(e));
    },
    hasAnyPermission (...requested) {
      return requested.map(e => e.trim()).some(e => this.permissions.has(e));
    },
  },
});